import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "paperclip",
  "use": "paperclip-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"paperclip\"><title>paperclip</title><path d=\"M13.828 4.172q-1.141-1.125-2.766-1.125-.766 0-1.469.281-.719.281-1.281.828L4.671 7.765q-.656.641-.648 1.555t.656 1.563 1.57.648h.016q.922 0 1.563-.641l3.203-3.156q.156-.156.156-.391t-.156-.391q-.172-.156-.398-.156t-.398.156l-3.188 3.156q-.328.328-.781.328H6.25q-.469-.016-.781-.328-.328-.328-.328-.789t.313-.773l3.641-3.609q.813-.781 1.969-.781 1.156 0 1.977.805t.82 1.945-.813 1.938l-3.859 3.828q-1.188 1.172-2.906 1.172-1.719 0-2.922-1.195T2.15 9.766t1.195-2.875l4.984-4.938q.156-.156.156-.383t-.156-.398q-.172-.156-.398-.156t-.398.156L2.549 6.11q-.734.734-1.141 1.703-.375.938-.375 1.953t.391 1.953q.391.969 1.141 1.719.75.734 1.734 1.125.938.391 1.984.391 1.031 0 1.969-.375.984-.391 1.719-1.125l3.875-3.828q.547-.547.844-1.266.281-.703.281-1.453 0-1.609-1.141-2.734z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/paperclip.svg
// module id = 478
// module chunks = 0